//@flow
// import React from 'react';
import Dispatcher from 'app/Dispatcher';

import {
  Cookies
} from 'react-cookie';
//
// import jwt from 'jsonwebtoken';

const ActionTypes = {
  SET_TOKEN: 'SET_TOKEM'
};

const Actions = {
  unsetToken() {
    let cookies = new Cookies();
    cookies.remove('token');
    Dispatcher.dispatch({
      type: ActionTypes.SET_TOKEN,
      token: null
    });
  },
  setToken(token: string) {

    //never set the token cookie from the portal. should be done in auth

    // let cookies = new Cookies();
    // cookies.set('token', token, {
    //   path: '/'
    // });


    // save the token in the store
    Dispatcher.dispatch({
      type: ActionTypes.SET_TOKEN,
      token: token
    });

    //remove token query string from url
    // window.history.replaceState({}, "", "/");
  }
}

export {
  Actions,
  ActionTypes
};